/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconTemperature = createReactComponent("temperature", "IconTemperature", [
  [
    "path",
    { d: "M10 13.5a4 4 0 1 0 4 0v-8.5a2 2 0 0 0 -4 0v8.5", key: "svg-0" }
  ],
  ["path", { d: "M10 9l4 0", key: "svg-1" }]
]);

export { IconTemperature as default };
//# sourceMappingURL=IconTemperature.js.map
